import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

let DOMPurify;
try { DOMPurify = require('dompurify'); } catch {}

export default function PRCommentsDialog({ open, onClose, comments = [] }) {
  const prLevel = Array.isArray(comments) ? comments.filter(c => !c.file) : [];
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { backgroundColor: '#161b22', border: '1px solid #30363d' } }}>
      <DialogTitle sx={{ color: '#f0f6fc' }}>PR Comments</DialogTitle>
      <DialogContent dividers sx={{ maxHeight: 520 }}>
        {prLevel.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {prLevel.map((c, idx) => (
              <Box key={`prc-${idx}`} sx={{ p: 1.5, border: '1px solid #30363d', borderRadius: 1, background: '#0d1117' }}>
                <Typography sx={{ color: '#7d8590', fontSize: 12, mb: 0.5 }}>{c.author || 'Unknown'} — {c.created_at || ''}</Typography>
                {DOMPurify ? (
                  <Typography component="div" sx={{ color: '#c9d1d9', whiteSpace: 'pre-wrap' }}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(String(c.body || '')) }}
                  />
                ) : (
                  <Typography component="div" sx={{ color: '#c9d1d9', whiteSpace: 'pre-wrap' }}>{String(c.body || '')}</Typography>
                )}
              </Box>
            ))}
          </Box>
        ) : (<Typography sx={{ color: '#7d8590' }}>No PR comments found.</Typography>)}
      </DialogContent>
      <DialogActions><Button onClick={onClose} sx={{ color: '#c9d1d9' }}>Close</Button></DialogActions>
    </Dialog>
  );
}




